// AM-048 F2 — بنر «سشن پایان یافت» (سومین بنر AM-045).
// عمداً کامپوننت جداست تا SessionBanner.tsx (دو حالت قبلی) دست‌نخورده بماند.
// این بنر به activeSession وابسته نیست؛ فقط به closedReason در store.
import { useEffect } from "react";

export type SessionEndedReason = "connection_lost" | "revoked";

interface SessionEndedBannerProps {
  reason: SessionEndedReason;
  onDismiss: () => void;
  autoDismissMs?: number;
}

const MESSAGES: Record<SessionEndedReason, string> = {
  connection_lost: "سشن به دلیل قطعی طولانی پایان یافت.",
  revoked: "دسترسی پشتیبان لغو شد و سشن پایان یافت.",
};

const COLORS: Record<SessionEndedReason, string> = {
  connection_lost: "#b45309",
  revoked: "#991b1b",
};

export function SessionEndedBanner({ reason, onDismiss, autoDismissMs = 15_000 }: SessionEndedBannerProps) {
  useEffect(() => {
    const timerId = setTimeout(onDismiss, autoDismissMs);
    return () => clearTimeout(timerId);
  }, [onDismiss, autoDismissMs]);

  return (
    <div
      role="alert"
      data-testid="session-ended-banner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        backgroundColor: COLORS[reason],
        padding: "8px 16px",
        fontSize: "14px",
        fontWeight: 500,
        color: "white",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      }}
    >
      <span>{MESSAGES[reason]}</span>
      <button
        type="button"
        onClick={onDismiss}
        className="btn"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.25)",
          color: "white",
          padding: "6px 12px",
          fontSize: "14px",
          flexShrink: 0,
          border: "1px solid rgba(0, 0, 0, 0.35)",
        }}
      >
        بستن
      </button>
    </div>
  );
}
